import { http_app } from './HttpService.js'

export default {
	load(params = '') {
		return http_app.get('marketing/campaigns' + params)
	},
	create(data) {
		return http_app.post('marketing/notifications', data)
	}
}